import { convertMdxToNoteContent } from "@/modules/notes/conversions";
import { createNoteEncodedContentFromTitle } from "@/store/note/helpers/create-note-content-from-title";

export type AiToolkitNoteContentForMutation = {
  encodedContent: string;
  primaryLabel: string;
  secondaryLabel: string;
};

export const buildNoteContentForCreate = ({
  title,
  bodyMdx,
}: {
  title?: string;
  bodyMdx?: string;
}): AiToolkitNoteContentForMutation | undefined => {
  if (bodyMdx !== undefined) {
    const mdx = title ? `# ${title}\n\n${bodyMdx}` : bodyMdx;
    const noteContent = convertMdxToNoteContent(mdx);

    return {
      encodedContent: noteContent.encodedContent,
      primaryLabel: noteContent.primaryLabel ?? title ?? "",
      secondaryLabel: noteContent.secondaryLabel ?? "",
    };
  }

  if (title) {
    return createNoteEncodedContentFromTitle(title);
  }

  return undefined;
};

export const buildNoteContentForUpdate = ({
  mdx,
  fallbackTitle,
}: {
  mdx: string;
  fallbackTitle: string;
}): AiToolkitNoteContentForMutation & {
  mediaKinds: ReturnType<typeof convertMdxToNoteContent>["mediaKinds"];
  mentions: ReturnType<typeof convertMdxToNoteContent>["mentions"];
  isEmpty: boolean;
} => {
  const noteContent = convertMdxToNoteContent(mdx);

  return {
    encodedContent: noteContent.encodedContent,
    primaryLabel: noteContent.primaryLabel ?? fallbackTitle,
    secondaryLabel: noteContent.secondaryLabel ?? "",
    mediaKinds: noteContent.mediaKinds,
    mentions: noteContent.mentions,
    isEmpty: noteContent.isEmpty,
  };
};
